<template>
    <v-layout wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 style="margin: auto;">
            <div>
                <v-tabs style="background-color: #00a650" dark
                        next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline"
                        show-arrows
                        v-model="activeTab"
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab :key="0">
                        Báo cáo sau bài tập
                    </v-tab>
                    <v-tab :key="1">
                        Báo cáo tháng
                    </v-tab>
                    <v-tab :key="2">
                        Báo cáo kỳ
                    </v-tab>
                    <v-tab :key="3">
                        Báo cáo riêng
                    </v-tab>
                    <v-tabs-items v-model="activeTab" :touchless="true">
                        <v-tab-item :key="0">
                            <lesson-report-page :class-id="classId" ref="lessonReport"/>
                        </v-tab-item>
                        <v-tab-item :key="1">
                            <month-report-page :class-id="classId" ref="monthlyReport"/>
                        </v-tab-item>
                        <v-tab-item :key="2">
                            <quarter-report-page :class-id="classId" ref="quarterlyReport"/>
                        </v-tab-item>
                        <v-tab-item :key="3">
                            <student-report-page :class-id="classId" ref="studentReport"/>
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>

                <!--div class="verticalToolbar yoprimary">
                    <v-btn dark flat title="Báo cáo sau bài tập" @click="reportType='lesson'">
                        <v-icon>done</v-icon>
                        &nbsp;Báo cáo sau bài tập
                    </v-btn>
                    <v-btn dark flat title="Báo cáo tháng" @click="reportType='month'">
                        <v-icon>date_range</v-icon>
                        &nbsp;Báo cáo tháng
                    </v-btn>
                    <v-btn dark flat title="Báo cáo kỳ" @click="reportType='term'">
                        <v-icon>calendar_today</v-icon>
                        &nbsp; Báo cáo kỳ
                    </v-btn>
                    <div style="border-bottom: 1px solid white;border-top: 1px solid gray"></div>
                    <v-btn dark flat title="Báo cáo riêng" @click="reportType='personal'">
                        <v-icon>emoji_people</v-icon>
                        &nbsp;Báo cáo riêng
                    </v-btn>
                </div-->
                <!--div v-if="reportType=='personal'">
                    <student-report-page :class-id="classId"/>
                </div>
                <div v-else-if="reportType=='lesson'">
                    <lesson-report-page :class-id="classId"/>
                </div>
                <div v-else-if="reportType=='month'">
                    <month-report-page :class-id="classId"/>
                </div>
                <div v-else-if="reportType=='term'">
                    <quarter-report-page :class-id="classId"/>
                </div>
                <div v-else>
                    <report-page :class-id="classId"/>
                </div-->
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import MonthReportPage from "./report/monthlyReport";
    import QuarterReportPage from "./report/quarterReport";
    import StudentReportPage from "./report/studentReport";
    import LessonReportPage from "./report/lessonReport";

    export default {
        name: "report-page",
        components: {LessonReportPage, StudentReportPage, QuarterReportPage, MonthReportPage},
        props: {
            classId: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            activeTab: "exerciseReport",
            display: "list",
            reportType: "lesson",
            exerciseReport: [],
        }),

        mounted() {
            this.activeTab = 0;
        },

        computed: {},

        watch: {
            classId: function (data) {
                this.activeTab = 0;
            },

            activeTab(value) {
                if (value == 0) {
                    this.$refs.lessonReport.getLessonReportList();
                } else if (value == 1) {
                    this.$refs.monthlyReport.getReportList();
                } else if (value == 2) {
                    this.$refs.quarterlyReport.getReportList();
                } else if (value == 3) {
                    this.$refs.studentReport.init();
                }
            }
        },

        created() {
            this.activeTab = 0;
            this.$refs.lessonReport.getLessonReportList();
        },
        methods: {
            showtab() {
                this.activeTab = 0;
            },

            showReportDetail(report) {
                if (report.reportType == 0) {
                    this.activeTab = 0;
                    this.$refs.lessonReport.viewReport(report);
                } else if (report.reportType == 2) {
                    this.activeTab = 1;
                    this.$refs.monthlyReport.viewReport(report);
                } else if (report.reportType == 3) {
                    this.activeTab = 2;
                    this.$refs.quarterlyReport.viewReport(report);
                } else {
                    this.activeTab = 3;
                    this.$refs.studentReport.viewReport(report);
                }
            },

            showReport(report) {
                if (report.reportType == 0) {
                    this.activeTab = 0;
                    this.$refs.lessonReport.viewReport(report);
                } else if (report.reportType == 2) {
                    this.activeTab = 1;
                    this.$refs.monthlyReport.viewReport(report);
                } else if (report.reportType == 3) {
                    this.activeTab = 2;
                    this.$refs.quarterlyReport.viewReport(report);
                } else {
                    this.activeTab = 3;
                    this.$refs.studentReport.viewReport(report);
                }
            },

            showReportOfPost(post) {
                axios.post(process.env.VUE_APP_API_URL + "/report/getReport?reportId=" + post.objectId).then(
                    data => {
                        let report = data;
                        if (report.reportType == 0) {
                            this.activeTab = 0;
                            this.$refs.lessonReport.viewReport(report);
                        } else if (report.reportType == 2) {
                            this.activeTab = 1;
                            this.$refs.monthlyReport.viewReport(report);
                        } else if (report.reportType == 3) {
                            this.activeTab = 2;
                            this.$refs.quarterlyReport.viewReport(report);
                        } else {
                            this.activeTab = 3;
                            this.$refs.studentReport.viewReport(report);
                        }
                    },
                    error => {
                        console.log(error);
                    }
                )
            }
        }
    };
</script>